import coprintIcon from "../assets/brand/coprint-icon.png";

export function Logo() {
  return (
    <div className="bw-logo" aria-label="Coprint">
      <img className="bw-logo-mark" src={coprintIcon} alt="" aria-hidden="true" />
      <span>Coprint</span>
    </div>
  );
}
